import classNames from 'classnames';
import React, { FC, useEffect } from 'react';

export const QADivider: FC<{
  text: string;
  childReadyTimer?: number;
  shouldStream: boolean;
  onReadyToShowNext: (timer: number) => void;
}> = ({ text, childReadyTimer, shouldStream, onReadyToShowNext }) => {
  useEffect(() => {
    if (!shouldStream) {
      return;
    }

    onReadyToShowNext(childReadyTimer ?? 600);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={classNames('relative bg-white my-4', {
        'animate-in fade-in ease-in-out duration-600': shouldStream,
      })}
    >
      <div className="border-[0.5px] border-solid border-cloud-15" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex gap-1 px-4 bg-white whitespace-nowrap">
        <div className="text-gray-50">{text}</div>
      </div>
    </div>
  );
};
